import i18n from '@/i18n';

const MSA_URL_EN = 'https://electric.ai/masterservicesagreements';
const MSA_URL_FR_CA =
  'https://electric.ai/electric-terms-of-service-canada-fr-ca';

export function getLocalizedMsaUrl(): string {
  const lang = i18n.language || 'en';
  return lang.split('-')[0] === 'fr' ? MSA_URL_FR_CA : MSA_URL_EN;
}
